import {
  CENTRAL_SERVICES,
  DEPOT_OPERATIONS,
  DEPOT_PLANNING,
  ODF,
} from '../constants/strings';

const appMenuConfig = [
  {
    title: DEPOT_OPERATIONS,
    link: `${import.meta.env.VITE_UNIVERSE_HOST}/cds/menuController.do?menu=depot`,
  },
  {
    title: CENTRAL_SERVICES,
    link: `${import.meta.env.VITE_UNIVERSE_HOST}/cds/menuController.do?menu=ccs`,
  },
  {
    title: ODF,
    link: `${import.meta.env.VITE_UNIVERSE_HOST}/drivers`,
  },
  {
    title: DEPOT_PLANNING,
    link: 'https://central.dpdgroup.co.uk/depot-management',
  },
];

export default appMenuConfig;
